/**
 * Торги Carlink по лиду СберАвто. Таблица public.carlink_lots и bucket
 * carlink-protocols пишет только edge carlink-sync (мост Carlink); консоль
 * читает (RLS: admin/dispatcher).
 */
import { createClient } from '@/api/supabase'

export interface CarlinkLot {
  lead_id: string
  report_key: number
  id_auction: number | null
  status: string | null
  workflow_status: string | null
  is_final: boolean
  dt_start: string | null
  dt_end: string | null
  finished_at: string | null
  lot_url: string | null
  protocol_path: string | null
  protocol_received_at: string | null
  updated_at: string
}

export async function getCarlinkLot(leadId: string): Promise<CarlinkLot | null> {
  const supabase = createClient()
  const { data, error } = await supabase
    .from('carlink_lots')
    .select('lead_id, report_key, id_auction, status, workflow_status, is_final, dt_start, dt_end, finished_at, lot_url, protocol_path, protocol_received_at, updated_at')
    .eq('lead_id', leadId)
    .maybeSingle()
  if (error) throw new Error(error.message)
  return (data as CarlinkLot | null) ?? null
}

/** Подписанная ссылка на PDF протокола торгов (10 мин). */
export async function getCarlinkProtocolUrl(path: string): Promise<string> {
  const supabase = createClient()
  const { data, error } = await supabase.storage.from('carlink-protocols').createSignedUrl(path, 600)
  if (error || !data?.signedUrl) throw new Error(error?.message ?? 'no_url')
  return data.signedUrl
}
